import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from 'src/app/auth/auth.service';
import { BannerConfig } from '../banner/banner.component';
import { AppService } from 'src/app/app.service';


@Component({
  selector: 'app-alert-event-manager',
  templateUrl: './alerts-event-manager.component.html',
  styleUrls: ['./alerts-event-manager.component.scss']
})
export class AlertsEventManagerComponent implements OnInit, OnDestroy {
  bannerConfig: BannerConfig = {
    theme: 'info',
    title: 'Say goodbye to manual monitoring!',
    description: 'Our upgraded alerts feature keeps you informed of any failing integrations in real-time.',
    buttonText: 'Check it here',
    buttonUrl: '/u/alerts/inbox'
  };
  showBanner = false;
  subscriptionBannerChecked = false;
  componentDestroy: Subject<any> = new Subject();
  @Input() userId: string;
  private dismissKey: string;
  private firstShownKey: string;

  constructor(private authService: AuthService, private appService: AppService) { }

  ngOnInit(): void {
    const bannerVersion = 'v2'; 
    this.dismissKey = `alertBannerDismissed_${this.userId}_${bannerVersion}`;
    this.firstShownKey = `alertBannerFirstShown_${this.userId}_${bannerVersion}`;
    this.appService.subscriptionBannerVisible$.pipe(
      takeUntil(this.componentDestroy)
    ).subscribe(isVisible => {
      this.subscriptionBannerChecked = true;
      this.showBanner = !isVisible && this.checkBannerStatus();
    });
    // this.showBanner = this.checkBannerStatus();

  }

  private checkBannerStatus(): boolean {
    const dismissedTimestamp = localStorage.getItem(this.dismissKey);
    if (dismissedTimestamp) {
      return false;
    } else {
      const firstShownTimestamp = localStorage.getItem(this.firstShownKey);
      if (!firstShownTimestamp) {
        // If banner has never been shown, record the first time it's shown and show it
        localStorage.setItem(this.firstShownKey, new Date().toISOString());
        return true;
      } else {
        const firstShownDate = new Date(firstShownTimestamp);
        const currentDate = new Date();
        const diffTime = Math.abs(currentDate.getTime() - firstShownDate.getTime());
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // Difference in days
        // If it's been more than 7 days, don't show the banner
        return diffDays <= 7;
      }
    }
  }

  dismissBanner(): void {
    localStorage.setItem(this.dismissKey, new Date().toISOString());
    this.showBanner = false;
  }

  ngOnDestroy(): void {
    this.componentDestroy.next();
    this.componentDestroy.complete();
  }
}
